var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner'),_c('BrandsLogos'),_c('About'),_c('Visions'),_c('Types'),_c('TypeDiv'),_c('Technology'),_c('ServicesType'),_c('WhyChooseUs'),_c('Portfolio'),_c('Const')],1)}
var staticRenderFns = []

export { render, staticRenderFns }